import type { ActivityItem, OfficialMenuGroup } from '@/apiSdk/api.type';
import type { LanguageCode } from '$/store/languageStore/types';

export type OfficialHomeLanguage = LanguageCode.zhHans | LanguageCode.en;

/** 仅引用已由 Smartcat 下发的通用文案；官网自维护内容集中在 localizedContent.ts。 */
export const OFFICIAL_HOME_TRANSLATION_KEYS = {
  login: 'RoboNeo_Web_login_content',
  downloadMobile: 'RoboNeo_Web_download_content',
  terms: 'RoboNeo_Web_user_agreement',
  privacy: 'RoboNeo_Web_privacy_policy',
  features: 'roboneo_web_function',
  generate: 'generate',
} as const;

export type OfficialHomeMessages = Record<keyof typeof OFFICIAL_HOME_TRANSLATION_KEYS, string>;

export interface OfficialHomePageProps {
  /** IP 解析得到的真实国家码；国内版的 HK / MO / TW 也保留原值传给接口。 */
  countryCode: string;
  /** 独立的文案语言，与国内版或海外版入口无关。 */
  languageCode: OfficialHomeLanguage;
  /** 当前请求的首屏文案，由 SSR 直接传递，避免全局 Store 导致并发请求串语言。 */
  messages: OfficialHomeMessages;
  /** 原始导航分组，按接口顺序展示 category 和 list，不按固定分类名称过滤。 */
  menus: OfficialMenuGroup[];
  activityList: ActivityItem[];
  /** SSR 和首次水合共用设备信息，保持首屏视频与预加载资源选择一致。 */
  userAgent: string;
}
